import { axiosModules } from "@qubit-utill/src";

export default {
  //pserver > EDR > EDR 방어/복구 명령어 > EDR 방어/복구 명령어 등록/수정
  createEdrDefenseCmd: (documentId, edrFilterElementId, data) => {
    return axiosModules.post(`/pserver/edrdefensecmd/${documentId}/${edrFilterElementId}`, data);
  },
};
